import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import { Button } from "GameObjects/UI/Button";
import { ITallyData } from "Data/ITallyData";
import { ResourceType } from "Data/ResourceType";
import { TimelineLite } from "gsap";
import * as Topics from "Data/Topics";
import * as VO from "Data/VoiceOver";
import {DWELL_DURATION} from "Data/Constants";
import Settings from "Data/Settings";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { RestStopGame } from "States/RestStopGame";
import { templateResources } from "Data/templateResources";
import { StressorType } from "Data/StressorType";
import { templateStressors } from "Data/templateStressors";

export class RestStopPond extends LayoutButton {
    public tallied: boolean = false;
    public tally: ITallyData = {
        resources: {},
        stressors: {},
    };

    protected readonly affectedBySettingsScale = false;
    public get nameVO() {
        return this.hoverVO as string;
    }
    public get image() {
        return this._image;
    }

    protected playKeyboardSelectVO(): void {
        // intentionally not calling super.playKeyboardSelectVO()
        HLF.Application.instance.voiceover.stopVO();
        this.playHoverVO();
    }

    protected playHoverVO() {
        if (Settings.audioDescriptionEnabled === false) {
            super.playHoverVO();
        }
        else {
            if (RestStopGame.graphType === "pictograph") {
                HLF.Application.instance.voiceover.stopVO();
                HLF.Application.instance.voiceover.playVO([
                    VO.REST_STOP_AUDIO_DESCRIPTION_10A,
                    this.nameVO,
                    VO.REST_STOP_AUDIO_DESCRIPTION_10B,
                    this.nameVO,
                ], {caption: {
                    id: VO.REST_STOP_AUDIO_DESCRIPTION_10A,
                    args: {
                        "POND": this.nameVO,
                        "_": VO.REST_STOP_AUDIO_DESCRIPTION_10B,
                        "__": this.nameVO,
                    }
                }});

                const stressorNames = Object.keys(this.tally.stressors) as StressorType[];
                const totalStressors: number = stressorNames.reduce((total, stressorName) => {
                    total += this.tally.stressors[stressorName] ?? 0;
                    return total;
                }, 0);

                let numberVO: string;
                switch (totalStressors) {
                    case 0:
                        numberVO = VO.REST_STOP_NUMBER_ZERO;
                        break;
                    case 1:
                        numberVO = VO.REST_STOP_NUMBER_ONE;
                        break;
                    case 2:
                        numberVO = VO.REST_STOP_NUMBER_TWO;
                        break;
                    case 3:
                        numberVO = VO.REST_STOP_NUMBER_THREE;
                        break;
                    case 4:
                        numberVO = VO.REST_STOP_NUMBER_FOUR;
                        break;
                    case 5:
                        numberVO = VO.REST_STOP_NUMBER_FIVE;
                        break;
                    case 6:
                        numberVO = VO.REST_STOP_NUMBER_SIX;
                        break;
                    case 7:
                        numberVO = VO.REST_STOP_NUMBER_SEVEN;
                        break;
                    case 8:
                        numberVO = VO.REST_STOP_NUMBER_EIGHT;
                        break;
                    case 9:
                        numberVO = VO.REST_STOP_NUMBER_NINE;
                        break;
                    case 10:
                        numberVO = VO.REST_STOP_NUMBER_TEN;
                        break;
                    case 11:
                        numberVO = VO.REST_STOP_NUMBER_ELEVEN;
                        break;
                    case 12:
                        numberVO = VO.REST_STOP_NUMBER_TWELVE;
                        break;
                }

                HLF.Application.instance.voiceover.playVO([
                    VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_PROBLEM_TALLY_UPDATED_A,
                    numberVO!,
                    VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_PROBLEM_TALLY_UPDATED_B,
                    this.nameVO,
                ], {
                    mode: HLF.PlayMode.Append,
                    caption: {
                        id: VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_PROBLEM_TALLY_UPDATED_A,
                        args: {
                            "NUMBER": numberVO!,
                            "POND": this.nameVO,
                            "_": VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_PROBLEM_TALLY_UPDATED_B,
                        }
                    }
                });

                const resourceNames = Object.keys(this.tally.resources) as ResourceType[];
                const totalResources: number = resourceNames.reduce((total, resourceName) => {
                    total += this.tally.resources[resourceName] ?? 0;
                    return total;
                }, 0);

                console.log("total resources: " + totalResources);

                switch (totalResources) {
                    case 0:
                        numberVO = VO.REST_STOP_NUMBER_ZERO;
                        break;
                    case 1:
                        numberVO = VO.REST_STOP_NUMBER_ONE;
                        break;
                    case 2:
                        numberVO = VO.REST_STOP_NUMBER_TWO;
                        break;
                    case 3:
                        numberVO = VO.REST_STOP_NUMBER_THREE;
                        break;
                    case 4:
                        numberVO = VO.REST_STOP_NUMBER_FOUR;
                        break;
                    case 5:
                        numberVO = VO.REST_STOP_NUMBER_FIVE;
                        break;
                    case 6:
                        numberVO = VO.REST_STOP_NUMBER_SIX;
                        break;
                    case 7:
                        numberVO = VO.REST_STOP_NUMBER_SEVEN;
                        break;
                    case 8:
                        numberVO = VO.REST_STOP_NUMBER_EIGHT;
                        break;
                    case 9:
                        numberVO = VO.REST_STOP_NUMBER_NINE;
                        break;
                    case 10:
                        numberVO = VO.REST_STOP_NUMBER_TEN;
                        break;
                    case 11:
                        numberVO = VO.REST_STOP_NUMBER_ELEVEN;
                        break;
                    case 12:
                        numberVO = VO.REST_STOP_NUMBER_TWELVE;
                        break;
                }
                HLF.Application.instance.voiceover.playVO([
                    VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_FOOD_TALLY_UPDATED_A,
                    numberVO!,
                    VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_FOOD_TALLY_UPDATED_B,
                    this.nameVO,
                ], {mode: HLF.PlayMode.Append, caption: {
                    id: VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_FOOD_TALLY_UPDATED_A,
                    args: {
                        "NUMBER": numberVO!,
                        "POND": this.nameVO,
                        "_": VO.REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_FOOD_TALLY_UPDATED_B,
                    }
                }});

            }
            else {
                HLF.Application.instance.voiceover.stopVO();
                HLF.Application.instance.voiceover.playVO([
                    VO.REST_STOP_AUDIO_DESCRIPTION_11A,
                    this.nameVO,
                    VO.REST_STOP_AUDIO_DESCRIPTION_11B,
                    this.nameVO,
                    VO.REST_STOP_AUDIO_DESCRIPTION_11C,
                    VO.REST_STOP_NUMBER_FOUR,
                ], {priority: 4, caption: {
                    id: VO.REST_STOP_AUDIO_DESCRIPTION_11A,
                    args: {
                        "POND": this.nameVO,
                        "NUMBER": VO.REST_STOP_NUMBER_FOUR,
                        "_": VO.REST_STOP_AUDIO_DESCRIPTION_11B,
                        "__": VO.REST_STOP_AUDIO_DESCRIPTION_11C,
                        "___": this.nameVO,
                    }
                }});

                const stressorNames = Object.keys(this.tally.stressors) as StressorType[];
                for (let i=0; i<stressorNames.length; i++) {
                    const height = this.tally.stressors[stressorNames[i]];
                    let numberVO: string;
                    let unitVO: string;
                    switch (height) {
                        case 1:
                            numberVO = VO.REST_STOP_NUMBER_ONE;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_D_ALT;
                            break;
                        case 2:
                            numberVO = VO.REST_STOP_NUMBER_TWO;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_D;
                            break;
                        case 3:
                            numberVO = VO.REST_STOP_NUMBER_THREE;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_D;
                            break;
                        case 4:
                            numberVO = VO.REST_STOP_NUMBER_FOUR;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_D;
                            break;
                    }

                    HLF.Application.instance.voiceover.playVO([
                        VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_A,
                        this.nameVO,
                        VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_B,
                        templateStressors[stressorNames[i]].hoverVO,
                        VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_C,
                        numberVO!,
                        unitVO!,
                    ], {mode: HLF.PlayMode.Append, caption: {
                        id: VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_A,
                        args: {
                            "POND": this.nameVO,
                            "ICON": templateStressors[stressorNames[i]].hoverVO,
                            "NUMBER": numberVO!,
                            "UNIT": unitVO!,
                            "_": VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_B,
                            "__": VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_C,
                        }
                    }});
                }

                const resourceNames = Object.keys(this.tally.resources) as ResourceType[];
                for (let i=0; i<resourceNames.length; i++) {
                    const height = this.tally.resources[resourceNames[i]];
                    let numberVO: string;
                    let unitVO: string;
                    switch (height) {
                        case 1:
                            numberVO = VO.REST_STOP_NUMBER_ONE;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_D_ALT;
                            break;
                        case 2:
                            numberVO = VO.REST_STOP_NUMBER_TWO;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_D;
                            break;
                        case 3:
                            numberVO = VO.REST_STOP_NUMBER_THREE;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_D;
                            break;
                        case 4:
                            numberVO = VO.REST_STOP_NUMBER_FOUR;
                            unitVO = VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_D;
                            break;
                    }

                    HLF.Application.instance.voiceover.playVO([
                        VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_A,
                        this.nameVO,
                        VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_B,
                        templateResources[resourceNames[i]].hoverVO,
                        VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_C,
                        numberVO!,
                        unitVO!,
                    ], {mode: HLF.PlayMode.Append, caption: {
                        id: VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_A,
                        args: {
                            "POND": this.nameVO,
                            "ICON": templateResources[resourceNames[i]].hoverVO,
                            "NUMBER": numberVO!,
                            "UNIT": unitVO!,
                            "_": VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_B,
                            "__": VO.REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_C,
                        }
                    }});
                }
            }
        }
    }
}